import { CategoryRounded } from "@material-ui/icons";
import axios from "axios";
import Constants from "../Constants/Constants";

export const getAllCategories = () => {
  return axios.get(`${Constants.BASE_URL}get_all_emergency_category`);
};

export const getProductData = (city, state, categories) => {
  return axios.get(`${Constants.BASE_URL}emergency_contacts?search_term=${categories}&city=${city}&state=${state}&country=India` );
};
